/** Texte für Telefonie und SIP - Deutsch ist die Referenz. */
export const deTelephony = {
  'campaign.tab.phone': 'Telefonieren',

  'call.title': 'Anrufen',
  'call.manualNumber': 'Telefonnummer',
  'call.start': 'Anrufen',
  'call.hangup': 'Auflegen',
  'call.mute': 'Stumm schalten',
  'call.unmute': 'Stummschaltung aufheben',
  'call.continue': 'Weiter telefonieren',
  'call.wrapUp': 'Ergebnis festhalten',
  'call.state.idle': 'Bereit',
  'call.state.dialing': 'Verbindung wird aufgebaut …',
  'call.state.ringing': 'Es klingelt …',
  'call.state.connected': 'Im Gespräch',
  'call.state.reconnecting': 'Verbindung unterbrochen – bitte warten',
  'call.state.ended': 'Gespräch beendet',
  'call.phoneUnavailable': 'Die Telefonie ist gerade nicht verfügbar. Bitte versuchen Sie es in einem Moment erneut.',
  'call.providerProblem':
    'Es gibt gerade ein Problem mit dem Telefonieanbieter. Bitte wenden Sie sich an Ihren Administrator.',
  'call.reconnected': 'Die Verbindung steht wieder.',

  'sip.title': 'Telefonieanbieter',
  'sip.hint': 'Diese Zugangsdaten bekommen Sie von Ihrem Telefonieanbieter.',
  'sip.host': 'Server',
  'sip.username': 'Benutzername',
  'sip.password': 'Passwort',
  'sip.passwordStored': 'Passwort gespeichert',
  'sip.passwordKeep': 'Leer lassen, um das gespeicherte Passwort zu behalten.',
  'sip.port': 'Port',
  'sip.transport': 'Übertragung',
  'sip.authId': 'Anmeldename',
  'sip.realm': 'Domain',
  'sip.mode': 'Zugangsart',
  'sip.mode.global': 'Ein Zugang für alle Caller',
  'sip.mode.individual': 'Eigener Zugang je Caller',
  'sip.test': 'Verbindung testen',
  'sip.test.ok': 'Verbindung zum Telefonieanbieter erfolgreich.',
  'sip.test.rejected':
    'Anmeldung beim Telefonieanbieter fehlgeschlagen. Bitte Benutzername und Passwort prüfen.',
  'sip.test.unreachable': 'Telefonieanbieter ist nicht erreichbar.',
  'sip.notConfigured': 'Für diese Kampagne ist noch kein Telefonieanbieter hinterlegt.',
  'sip.forUser': 'Zugang für',

  'error.sip.not_configured': 'Für diese Kampagne ist noch kein Telefonieanbieter hinterlegt.',
  'error.sip.not_configured_for_user': 'Für Sie ist in dieser Kampagne noch kein Telefonieanbieter hinterlegt.',
  'error.sip.wrong_mode': 'Diese Zugangsart passt nicht zur Einstellung der Kampagne.',
  'error.sip.password_required': 'Bitte das Passwort des Telefonieanbieters eingeben.',
  'error.sip.incomplete': 'Bitte Server und Benutzernamen eingeben.',
  'error.call.not_found': 'Dieses Gespräch wurde nicht gefunden.',
  'error.call.not_ended': 'Das Gespräch läuft noch.',
  'error.call.already_active': 'Sie führen bereits ein Gespräch.',
  'error.call.sales_result_required': 'Bitte halten Sie das Ergebnis des Gesprächs fest.',
  'error.call.required_fields_missing': 'Bitte füllen Sie die markierten Felder aus.',
  'error.campaign.stopped': 'Diese Kampagne ist gestoppt. Bitte wenden Sie sich an Ihren Administrator.',
  'error.campaign.calls_in_progress':
    'In dieser Kampagne wird gerade telefoniert. Bitte warten Sie, bis die Gespräche beendet sind.',
  'error.billing.insufficient_balance':
    'Ihr Guthaben reicht nicht für ein weiteres Gespräch. Bitte laden Sie Guthaben auf.',
  'error.telephony.unavailable':
    'Die Telefonie ist gerade nicht verfügbar. Bitte versuchen Sie es in einem Moment erneut.',
  'error.telephony.failed': 'Der Anruf konnte nicht aufgebaut werden.',
  'call.microphoneDenied':
    'Der Browser hat den Zugriff auf das Mikrofon abgelehnt. Bitte erlauben Sie ihn für diese Seite und laden Sie die Seite neu.',
  'call.microphoneMissing':
    'Es ist kein Mikrofon angeschlossen. Bitte verbinden Sie ein Headset und laden Sie die Seite neu.',
  'call.microphoneBusy':
    'Das Mikrofon wird gerade von einem anderen Programm benutzt. Bitte schließen Sie es und laden Sie die Seite neu.',
  'call.microphoneUnavailable':
    'Dieser Browser kann das Mikrofon hier nicht freigeben. Bitte verwenden Sie einen aktuellen Chrome oder Firefox.',
  'call.microphoneError':
    'Das Mikrofon konnte nicht geöffnet werden. Bitte laden Sie die Seite neu.',
} as const;
